// Function loadWoolLabSwatchBlock loads the WoolLabSwatchBlock class by dynamically importing the js on demand if needed

export function loadWoolLabSwatchBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-block-chunk" */ '../widgets/woolLabSwatchBlock').then(wg => {

		const { WoolLabSwatchBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabSwatchBlock"]');

		if(!$wg) {
			// console.info('WoolLabSwatchBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabSwatchBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabSwatchBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabSwatchBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabSwatchBlock widget');

}
